import { getApiEndpoint, getMflApiEndpoint } from "shared/utils/env.js";

export const get = async (target, handleSuccess, handleError, credentials = true) => {
  try {
    let init = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    if (target.startsWith(getApiEndpoint())) {
      if (credentials) {
        init.credentials = "include";
      }
    }

    const response = await fetch(target, init);
    const jsonData = await response.json();

    if (jsonData.errors) {
      handleError(jsonData.errors);
    } else {
      handleSuccess(jsonData);
    }
  } catch (error) {
    handleError(error);
  }
};

export const post = async (target, body, handleSuccess, handleError, credentials = true) => {
  try {
    let init = {
      method: "POST",
      body,
      headers: {
        "Content-Type": "application/json",
      },
    };

    if (target.startsWith(getApiEndpoint())) {
      if (credentials) {
        init.credentials = "include";
      }
    }

    const response = await fetch(target, init);
    const jsonData = await response.json();

    if (jsonData.errors) {
      handleError(jsonData);
    } else {
      handleSuccess(jsonData);
    }
  } catch (error) {
    handleError(error);
  }
};

export const loginPost = async (target, body, handleSuccess, handleError) => {
  try {
    const response = await fetch(target, {
      method: "POST",
      body,
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    const jsonData = await response.json();

    if (jsonData.errors) {
      handleError(jsonData);
    } else {
      handleSuccess(jsonData);
    }
  } catch (error) {
    handleError(error);
  }
};

export const download = async (target, filename = "file.csv", handleError = null) => {
  try {
    let init = {
      method: "GET",
    };

    const response = await fetch(target, init);

    if (!response.ok) {
      throw new Error("Download failed");
    }

    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    if (handleError) handleError(error);
    else console.error(error);
  }
};
